module.exports = __webpack_public_path__ + "img/xls.04cf833d.svg";